/**
 * Watcher do convite de push — irmão do `BadgeUnlockWatcher`.
 *
 * Montado uma única vez em `AppRoutes`. Aqui só mora a elegibilidade (logado,
 * onboarding concluído); todo o "quando" vive em `usePushPromptGate`.
 *
 * A folha é `lazy` porque ela arrasta `useFcmToken` → `firebase/messaging`, e
 * quem já respondeu ao convite (a maioria das sessões, para sempre depois da
 * primeira) não pode pagar esse chunk no bundle de entrada — que já é a queixa
 * de perf medida em 03/08.
 */

import { lazy, Suspense } from "react";
import { useAuth } from "../../../hooks/useAuth";
import { usePushPromptGate } from "../hooks/usePushPromptGate";

const PushPermissionSheet = lazy(() =>
  import("./PushPermissionSheet").then((m) => ({ default: m.PushPermissionSheet })),
);

export function PushPermissionWatcher() {
  const { user, profile } = useAuth();
  const eligible = !!user && profile?.onboardingCompleted === true;
  /*
   * A prova de que a permissão virou canal: token deste device no perfil.
   * Sai do `AuthContext` que já está montado — zero read. Sem isso, quem
   * concedeu num build sem APNs some do convite para sempre, contado como
   * quem disse sim (ver `utils/pushPlatformGate.ts`).
   */
  const hasRegisteredToken = (profile?.fcmTokens?.length ?? 0) > 0;
  const { open, close } = usePushPromptGate(eligible, hasRegisteredToken);

  if (!open) return null;

  return (
    <Suspense fallback={null}>
      <PushPermissionSheet onClose={close} />
    </Suspense>
  );
}
